import { IPanelTableData } from './../../shared-panel-components/panel-table/panel-table.models';
import {
  ITableConfig,
  IAttendancePanelData,
  IAttendancePanelState,
  IAttendanceStudent,
  IAttTable,
  IColDefItem,
  IRowDataItem,
  ITableRowConfig,
} from './attendance-panel.models';
import { switchMap } from 'rxjs/operators';
import { Observable, Observer, BehaviorSubject } from 'rxjs';
import {
  HISTORIC_ATT_TABLE_CONFIG,
  THIS_WEEK_ATT_TABLE_CONFIG,
  THIS_YEAR_ATT_TABLE_CONFIG,
} from './attendance-panel.constants';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'attendance-panel',
  template: require('./attendance-panel.component.html'),
  styles: [require('./attendance-panel.component.scss')],
})
export class AttendancePanelComponent {
  @Input() currentStudent$: BehaviorSubject<IAttendanceStudent>;
  @Input() expanded: boolean;
  @Output() panelStateEmitter = new EventEmitter<IAttendancePanelState>();

  public title: string = 'Attendance';
  public panelData$: Observable<{ key: IPanelTableData }>;

  ngOnInit(): void {
    const configs = { THIS_YEAR_ATT_TABLE_CONFIG, THIS_WEEK_ATT_TABLE_CONFIG, HISTORIC_ATT_TABLE_CONFIG };
    this.panelData$ = this.currentStudent$.pipe(switchMap(this.getPanelData$.bind(this, configs)));
  }

  public emitPanelState(state: boolean, emitter: EventEmitter<IAttendancePanelState>): void {
    emitter.emit({ key: 'ATTENDANCE', state });
  }

  private getPanelData$(
    configs: { [key: string]: ITableConfig },
    student: IAttendanceStudent,
  ): Observable<IAttendancePanelData> {
    const { THIS_YEAR_ATT_TABLE_CONFIG, THIS_WEEK_ATT_TABLE_CONFIG, HISTORIC_ATT_TABLE_CONFIG } = configs;
    return Observable.create((observer: Observer<any>) => {
      const thisYearAttTable = this.getTableData(student, THIS_YEAR_ATT_TABLE_CONFIG);
      const thisWeekAttTable = this.getTableData(student, THIS_WEEK_ATT_TABLE_CONFIG);
      const historicAttTable = this.getTableData(student, HISTORIC_ATT_TABLE_CONFIG);
      observer.next({ thisYearAttTable, thisWeekAttTable, historicAttTable }), observer.complete();
    });
  }

  private getTableData(student: IAttendanceStudent, config: ITableConfig): IAttTable {
    const colDefs: Array<IColDefItem> = Object.values(config.colDefs).map(({ key, human: value }) => ({ key, value }));
    const rowData: Array<IRowDataItem> = config.rows.map(this.convertRowConfigToTableRow.bind(this, student, config));
    return { colDefs, rowData };
  }

  private convertRowConfigToTableRow(
    student: IAttendanceStudent,
    config: ITableConfig,
    rowData: Array<ITableRowConfig>,
  ): Array<IRowDataItem> {
    return rowData.map(({ key, path, human }) => {
      return {
        key,
        value: path ? config.colDefs[key].valueFormatter(student[path]) : human,
        styles: key !== 'STUB' ? config.colDefs[key].cellStyles(student[path]) : null,
      };
    });
  }
}
